import {React, observer, observable, classNames, Fragment} from '@api'
import { Spinner } from '@blueprintjs/core'
import { CloudUpload } from '@material-ui/icons'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import {computed} from 'mobx'
import {ReportHeaderChip} from '.'
import * as css from './RecentReportsHeaderChips.css'

/// region Store

export class RecentReportsHeaderChipsStore extends VipLocalStore {
  constructor(stores: StoresInstance) {
    super(stores)
  }

  @observable foo = false

  @computed get disabled() {
    const {stores: {reports: {currentReport}}} = this
    return currentReport?.saving || !currentReport?.canSave
  }
}

export const RecentReportsHeaderChipsStoreContext = React.createContext<RecentReportsHeaderChipsStore>(null)
export const useRecentReportsHeaderChipsStore = () => React.useContext(RecentReportsHeaderChipsStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const RecentReportsHeaderChips = observer<MyProps>(function RecentReportsHeaderChips({className, ...props}) {
  const store = useVipLocalStore((stores) => new RecentReportsHeaderChipsStore(stores)),
    {disabled, stores: {catalog, catalog: {idFor}, reports: {currentReport, recentReports}, currentUser: {userSettings}}} = store

  return (
    <RecentReportsHeaderChipsStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        {currentReport && <Fragment>
            <ReportHeaderChip report={currentReport} index={0}/>
            {/*<ReportDraftDropdownButton />*/}
            {/*<NewMaximizedTabToolbarDropdown />*/}
        </Fragment>}

        {/*<NewReportHeaderChip />*/}

        {false && currentReport && !userSettings?.autoSaveReports &&
         <PrimaryIconButton tooltip='Save Changes'
                            tooltipPosition='bottom'
                            disabled={disabled}
                            icon={<CloudUpload/>}
                            onClick={() => currentReport.updateSettings(catalog.reportSettings)}/>}
      </div>
    </RecentReportsHeaderChipsStoreContext.Provider>)
})

/// endregion



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/RecentReportsHeaderChips.tsx